export default {
  DefaultTimeZone: 'America/New_York',
};
